export default [
    {
        path: 'bnafar-parametrizacao',
        component: () => import(/* webpackChunkName: 'integracao-bnafar-parametrizacao' */ '@/views/integracao/bnafar/parametrizacao/Index'),
        redirect: 'bnafar-parametrizacao/create',
        children: [
            {
                name: 'integracao-bnafar-parametrizacao-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'integracao-bnafar-parametrizacao' */ '@/views/integracao/bnafar/parametrizacao/Form'),
            },
        ],
    },
]